export const APPWRAPPER_BACKGROUNDS = {
  darkColor: '#374151',
  lightColor: 'rgba(55,65,81,0.2)',
}
